import { render, staticRenderFns } from "./lrFullscreenDialog.vue?vue&type=template&id=4c6833aa"
import script from "./lrFullscreenDialog.vue?vue&type=script&lang=js"
export * from "./lrFullscreenDialog.vue?vue&type=script&lang=js"
import style0 from "./lrFullscreenDialog.vue?vue&type=style&index=0&id=4c6833aa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports